import {useEffect, useRef} from "react";
import {useMap} from "react-leaflet";

const ZoomListener = ({mapLoaded, focusMarker}) => {
    const map = useMap();
    const zoomedRef = useRef(false);

    useEffect(() => {
        if (!map) return;

        if (!mapLoaded) {
            zoomedRef.current = false;
            return;
        }

        if (zoomedRef.current) return;

        const zoomToDefault = () => {
            const maxZoom = map.getMaxZoom();
            const minZoom = map.getMinZoom?.();
            if (typeof maxZoom !== "number") return;

            const targetZoom = typeof minZoom === "number" ? Math.max(minZoom, Math.min(20, maxZoom)) : Math.min(20, maxZoom);
            if (focusMarker?.lat != null && focusMarker?.lng != null) {
                map.flyTo([focusMarker.lat, focusMarker.lng], targetZoom, {animate: false});
            } else {
                map.setZoom(targetZoom);
            }
            zoomedRef.current = true;
        };

        map.whenReady(zoomToDefault);
    }, [map, mapLoaded, focusMarker?.lat, focusMarker?.lng]);

    return null;
};

export default ZoomListener;
